module.exports = __webpack_public_path__ + "img/camcorder.ffdb297c.svg";